import HrbTranslate from "../../language/HrbTranslate";
import '../personal-info/PersonalInfo.scss';
import CardWithTitleButton from '../../card-widget/CardWithTitleButton'
import ActionButton from '../../button/ActionButton';
import smsIcon from '../../../resources/images/sms.svg';
import authenticatorAppIcon from '../../../resources/images/authenticator_app.svg';

const SecondaryAuthMethod = (props) => {
    const { onReset, secondaryAuthenticationFactors} = props;
    const secondaryAuthenticationFactor = secondaryAuthenticationFactors && secondaryAuthenticationFactors.length > 0 ? secondaryAuthenticationFactors[0] : null;
    const getIcon = (type) => {
        switch (type) {
            case 'phone':
                return smsIcon;
            default:
                return authenticatorAppIcon;
        }
    };
    const getAuthMethod = (type) => {
        switch (type) {
            case 'phone':
                return 'profile.secondary_auth_info.sms';
            default:
                return 'profile.secondary_auth_info.authenticator_app'; 
        }
    };

    return (
        <CardWithTitleButton
            onTitleButtonClick={() => onReset(secondaryAuthenticationFactor?.type)}
            titleKey='profile.secondary_auth_info.title'
            buttonLabelKey={ secondaryAuthenticationFactor !== null ? 'profile.secondary_auth_info.reset_button': null }
            buttonClass="hrb-profile-button"
            isDisabled={false}>
            <div className="hrb-profile-secondary-authentication-container">
                { secondaryAuthenticationFactor !== null &&
                    <>
                        <div className="hrb-profile-secondary-authentication-content">
                            <div className="hrb-profile-secondary-authentication-content-title">
                                <img src={getIcon(secondaryAuthenticationFactor.type)} />
                                <HrbTranslate text={getAuthMethod(secondaryAuthenticationFactor.type)} />
                            </div>
                            <p>{' ' + secondaryAuthenticationFactor.data}</p>
                        </div>
                    </>
                }
                {secondaryAuthenticationFactor === null &&
                    <HrbTranslate text='profile.secondary_auth_info.content_after_reset' />
                }
                {secondaryAuthenticationFactor !== null &&
                    <ActionButton text={'profile.secondary_auth_info.reset_button'} onClick={() => onReset(secondaryAuthenticationFactor.type)} buttonClass="hrb-profile-secondary-button" />
                }
            </div>
        </CardWithTitleButton>
    );
}

export default SecondaryAuthMethod;